export enum RequestASessionClickTarget {
  LINK_TO_MATCH_FLOW = 'link-to-match-flow',
  QUICK_CHECKOUT_BUTTON = 'quick-checkout-button'
}
